/**
 * Composable per rendere utilizzabili su touch i menu Bootstrap con
 * `.dropdown-submenu` annidati (che di default si aprono solo via :hover CSS).
 * Sotto i 992px il tap sulla voce padre apre/chiude esplicitamente il
 * sottomenu invece di seguire il link; su desktop non interferisce.
 */

import { onMounted, onBeforeUnmount } from 'vue';

const MOBILE_BREAKPOINT = 992;

export function useSubmenuTouch(containerRef) {
	function handleClick(event) {
		if (window.innerWidth >= MOBILE_BREAKPOINT) return;
		if (!containerRef.value) return;

		const toggle = event.target.closest('.dropdown-submenu > a');
		if (!toggle || !containerRef.value.contains(toggle)) return;

		event.preventDefault();
		event.stopPropagation();

		const submenu = toggle.parentElement.querySelector(':scope > .dropdown-menu');
		if (!submenu) return;

		const wasOpen = submenu.classList.contains('show');

		containerRef.value.querySelectorAll('.dropdown-submenu > .dropdown-menu.show').forEach((el) => {
			el.classList.remove('show');
		});

		if (!wasOpen) submenu.classList.add('show');
	}

	onMounted(() => {
		document.addEventListener('click', handleClick, true);
	});

	onBeforeUnmount(() => {
		document.removeEventListener('click', handleClick, true);
	});
}
